export function normalize(input: string): string {
  return input
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[¿?¡!.,;:"'()]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function stripPunctuation(word: string): string {
  return word.replace(/[¿?¡!.,;:"'()]/g, "");
}

export function capitalize(input: string): string {
  if (!input) return input;
  const first = input.search(/[a-zA-ZÀ-ÿ]/);
  if (first < 0) return input;
  return input.slice(0, first) + input.charAt(first).toUpperCase() + input.slice(first + 1);
}

export function shuffle<T>(items: T[]): T[] {
  const copy = [...items];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}
